// extracted by mini-css-extract-plugin
export var container = "_s-0";
export var disabled = "_s-4";
export var fullWidth = "_s-3";
export var lined = "_s-1";
export var selected = "_s-5";
export var tab = "_s-2";